import { ReportCommission } from '@/app/services/reportService/reportComissions'
import { comissionPercentage } from '@/app/utils/comissionPercentage'
import { formatMoneyValue } from '@/app/utils/formatMoneyValue'
import { formatName } from '@/app/utils/formatName'
import { createColumnHelper } from '@tanstack/react-table'
import { format } from 'date-fns'
import { TypeCommissionMap } from '../useReportCommissionController'
import { cn } from '@/app/utils/cn'
import { useAuth } from '@/app/hooks/useAuth'
import { useMemo } from 'react'

const columnHelper = createColumnHelper<ReportCommission>()

export const TableReportCommissionColumnsDefinition = () => {
  const { isSeller } = useAuth()
  const columns = useMemo(() => {
    return [
      columnHelper.accessor('user', {
        id: 'vendedor',
        header: () => (
          <div
            className={cn(
              'flex w-full flex-col items-start gap-1 pl-2',
              isSeller && 'md:hidden',
            )}
          >
            <div className={cn('block', isSeller && 'hidden')}>Vendedor</div>
            <div
              className={cn('block  md:hidden', !isSeller && 'text-black04')}
            >
              Transação
            </div>
            <div className="block text-black04 sm:hidden">Valor</div>
          </div>
        ),
        cell: ({ row }) => (
          <div
            className={cn(
              'flex flex-col items-start gap-1 pl-4',
              isSeller && 'md:hidden',
            )}
          >
            <div className={cn('block', isSeller && 'hidden')}>
              <p>{formatName(row.original.user)}</p>
            </div>
            <div
              className={cn('block  md:hidden', !isSeller && 'text-black04')}
            >
              {row.original.transaction_contract}
            </div>
            <div className="block text-black04 sm:hidden">
              {formatMoneyValue(row.original.value)}
              {comissionPercentage(
                row.original.value,
                row.original.transaction_value,
              )}
            </div>
          </div>
        ),
      }),
      columnHelper.accessor('transaction_contract', {
        id: 'transaction_contract',
        header: () => (
          <div className="hidden text-center md:block">Transação</div>
        ),
        cell: ({ row }) => (
          <div className="hidden text-center md:block">
            {row.original.transaction_contract}
          </div>
        ),
      }),
      columnHelper.accessor('value', {
        id: 'value',
        header: () => <div className="hidden text-center sm:block">Valor</div>,
        cell: ({ row }) => (
          <div className="flex flex-col items-center gap-1">
            <div className="hidden sm:block">
              {formatMoneyValue(row.original.value)}{' '}
              {comissionPercentage(
                row.original.transaction_value,
                row.original.value,
              )}
            </div>
          </div>
        ),
      }),
      columnHelper.accessor('createdAt', {
        id: 'data',
        header: () => (
          <div className="hidden pr-4 text-center xl:block">Data</div>
        ),
        cell: ({ row }) => (
          <div className="hidden pr-4 text-center xl:block">
            {format(row.original.createdAt, 'dd/MM/yyyy, HH:mm')}
          </div>
        ),
      }),
      columnHelper.accessor('type', {
        id: 'type',
        header: () => (
          <div className="flex flex-col items-end gap-1 pr-2 xl:items-center xl:pr-0">
            <div>Tipo</div>
            <div className="block text-black04 xl:hidden">Data</div>
          </div>
        ),
        cell: ({ row }) => {
          return (
            <div className="flex flex-col items-end gap-1 pr-4 xl:items-center xl:pr-0">
              {TypeCommissionMap[row.original.type] || row.original.type}
              <div className="block text-black04 xl:hidden">
                {format(row.original.createdAt, 'dd/MM/yyyy, HH:mm')}
              </div>
            </div>
          )
        },
      }),
    ]
  }, [isSeller])
  return {
    columns,
  }
}
